import { render, staticRenderFns } from "./ButtonCrearSolicitud.vue?vue&type=template&id=5089931c&scoped=true&"
import script from "./ButtonCrearSolicitud.vue?vue&type=script&lang=ts&"
export * from "./ButtonCrearSolicitud.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonCrearSolicitud.vue?vue&type=style&index=0&id=5089931c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5089931c",
  null
  
)

export default component.exports